module.exports = __webpack_public_path__ + "media/images/favicon/safari-pinned-tab-60e06583c5d0b898c7f7182051bbc0be.svg";